import { useTranslation } from 'react-i18next';
import type { GanttGroup } from './types';
import DeleteIcon from '../../assets/icons/delete.svg?react';
import styles from './GanttGroupLabel.module.css';

interface GanttGroupLabelProps {
  group: GanttGroup;
  isEditMode?: boolean;
}

export const GanttGroupLabel = ({ group, isEditMode }: GanttGroupLabelProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.label}>
      <span className={styles.labelText}>{group.templateName}</span>
      <button
        type="button"
        className={styles.deleteButton}
        aria-label={t('delete-row')}
        aria-hidden={!isEditMode}
        tabIndex={isEditMode ? 0 : -1}
      >
        <DeleteIcon className={styles.deleteIcon} />
      </button>
    </div>
  );
};
